<template>
  <bk-formItem v-if="$attrs">
    <bk-view class="bk-autoComplete">
      <a-auto-complete 
        :value="completeText"
        :options="dataSource"
        :placeholder="placeholderText"
				:filter-option="filterOption"
        @change="handleChange"
      >
      </a-auto-complete>
      <bk-icon class="view-iconRight" icon="icon-xiala" />
    </bk-view>
  </bk-formItem>
</template>

<script>
	export default {
		name:'bk-autoComplete',
		props:{
			value:[String, Number],
			label:String,
			dataList:Array,
			field:{
				type:Object,
				default (){
					return { key:'key', label:'label'};
				}
			}
		},
		computed:{
			completeText (){
				let res = this.label;
				if(this.$bk_notNull(this.value)){
					res = this.$bk_findItem(this.dataSource, this.value, this.field.key).value;
				}
				return res || '';
			},
			dataSource (){
				return this.dataList?.map((item) => {
					let newsItem = {...item};
					newsItem.key = newsItem[this.field.key];
					newsItem.value = newsItem[this.field.label] || this.$bk_getTextWithLangCode(newsItem.labelCode);
					return newsItem;
				});
			},
			placeholderText (){
				return this.$bk_getTextWithLangCode('select_def_placeholder');
			}
		},
		methods:{
			filterOption (input, option){
				return option.value.toUpperCase().indexOf(input.toUpperCase()) >= 0;
			},
			handleChange (val){
				let curItem = this.$bk_findItem(this.dataSource, val, 'value');
				this.$emit('update:value', this.$bk_notNull(curItem.key) ? curItem.key : '');
				this.$emit('update:label', this.$bk_isNull(curItem.key) ? val : '');
			}
		}
	};
</script>

<style lang="less">
@import './bk-autoComplete.less';
</style>